import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {setupMotion, revealElements} from '../lib/reduced-motion.js';

gsap.registerPlugin(ScrollTrigger);

class ZoomAnimation {
  constructor(element) {
    this.element = element;
    this.zoomCard = null;
  }

  init() {
    setupMotion(gsap, {
      reduced: () => {
        // Make cards visible and at rest; no scroll timeline.
        const nodes = this.element.querySelectorAll('[data-element="zoom-scroll-element"]');
        const elements = gsap.utils.toArray(nodes);
        if (elements.length) {
          gsap.set(elements, {autoAlpha: 1, scale: 1});
        }
        revealElements(gsap, this.element, '[data-element]');
      },
      full: () => {
        this.zoomCard = gsap.timeline({
          scrollTrigger: {
            trigger: this.element,
            toggleActions: 'play pause resume reset',
            // scrub: 1,
            end: 'top 5%',
          },
        });

        this.zoomCard.add(this.addZoomCard());
      },
    });
  }

  addZoomCard() {
    const tl = gsap.timeline();
    const elementNodes = this.element.querySelectorAll('[data-element="zoom-scroll-element"]');
    const elements = gsap.utils.toArray(elementNodes);

    tl.from(elements, {
      duration: 1,
      ease: 'power3.inOut',
      scale: 0.9,
    });

    return tl;
  }
}

const zoomAnimations = {
  init() {
    const animationContainer = document.querySelectorAll('[data-module="scroll-zoom-animation"]');

    if (animationContainer && animationContainer.length) {
      animationContainer.forEach((container) => {
        const animation = new ZoomAnimation(container);
        animation.init();
      });
    }
  },
};

export default zoomAnimations;
